import { render } from "./ProjectsListCoord.vue?vue&type=template&id=0b4d43e6&scoped=true"
import script from "./ProjectsListCoord.vue?vue&type=script&lang=js"
export * from "./ProjectsListCoord.vue?vue&type=script&lang=js"

import "./ProjectsListCoord.vue?vue&type=style&index=0&id=0b4d43e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4d43e6"]])

export default __exports__